var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperiences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12591_10740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.0298L0.454253 13.484L1.96915 14.9989L2.4234 15.4532L2.87765 14.9989C3.46904 14.4075 4.40754 14.4075 4.99893 14.9989C5.59032 15.5903 5.59032 16.5288 4.99893 17.1202L4.54468 17.5745L4.99893 18.0287L6.51382 19.5436L6.96807 19.9979L7.42233 19.5436L19.5436 7.42233L19.9979 6.96807L19.5436 6.51382L18.0287 4.99893L17.5745 4.54468L17.1202 4.99893C16.5288 5.59032 15.5903 5.59032 14.9989 4.99893C14.4075 4.40754 14.4075 3.46904 14.9989 2.87765L15.4532 2.4234L14.9989 1.96915L13.484 0.454253L13.0298 0L12.5755 0.454253L0.454253 12.5755L0 13.0298ZM1.81916 13.0298L9.69574 5.15106L14.8468 10.3021L6.96807 18.1808L6.29955 17.5123C6.95736 16.441 6.83308 15.0161 5.90744 14.0883C4.98179 13.1626 3.5526 13.0319 2.47911 13.6897L1.81701 13.0276L1.81916 13.0298ZM10.6064 4.24255L13.0298 1.81916L13.6919 2.48125C13.0341 3.5526 13.1648 4.98393 14.0904 5.90958C15.0161 6.83523 16.441 6.96165 17.5145 6.30169L18.183 6.97022L15.7596 9.39362L10.6085 4.24255H10.6064ZM6.97022 8.78723L7.8123 10.7671L6.35312 12.4148L8.51725 12.1834L9.59717 14.039L10.0943 11.9134L12.2198 11.4163L10.3643 10.3364L10.5957 8.17227L8.94793 9.63146L6.96807 8.78937L6.97022 8.78723Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12591_10740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiences);
export default __webpack_public_path__ + "static/media/Experiences.65f8a95bd53d5a283eb4d99d03804800.svg";
export { ForwardRef as ReactComponent };